import React, { useEffect, Fragment, useMemo, useState } from "react"
import { withRouter } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { Card, Box, Button } from "@material-ui/core"
import {
  CircularProgress,
  Tooltip,
} from "../../../../node_modules/@material-ui/core/index"
import { MuiThemeProvider } from "@material-ui/core/styles"
import { getSoloCall, updateSolo } from "../../../actions/solos"
import { openSnackBar } from "../../../actions/snack-bar"
import CrewMamaAppBarComponent from "../../../components/CrewmamaAppBar/index"
import SoloHeader from "../../../components/Billing/Solos/SoloHeader/index"
import BillingPageLayout from "../../../components/Billing/Common/BillingPageLayout/index"
import SoloTableHeader from "../../../components/Billing/Solos/SoloTableHeader/index"
import SoloTable from "../../../components/Billing/Solos/SoloTable/index"
import billingTheme from "../../../themes/billing"
import NoteBox from "../../../components/Billing/Common/NoteBox/index"
import CopyLinkButton from "../../../components/Billing/Common/CopyLinkButton/index"
import { getExpensesTypesList } from "../../../actions/billing"
import DownloadPdfButton from "../../../components/Billing/Common/DownloadPdfButton/index"
import calculateTotals from "../../../utils/calculateTotals"
import SoloAdminActions from "../../../components/Billing/Admin/SoloAdminActions/index"
import ExpenseTableTotal from "../../../components/Billing/Common/ExpenseTableTotal/index"
import convertAdeskToOrganization from "../../../utils/convertAdeskToOrganization"
import useActiveCompanyAdesk from "../../../hooks/useActiveCompanyAdesk"
import { adeskPhones } from "../../../utils/adeskPhones"

const SoloInvoice = props => {
  const dispatch = useDispatch()
  let id = props.match.params.id

  const [invoiceData, setInvoiceData] = useState({
    client_id: null,
    client_company_id: null,
    client_name: "",
    client_company_name: "",
    client_phone: null,
    client_company_location: null,
    company_name: "",
    sent: null,
    sent_to: "",
    invoice_creation_date: null,
    invoice_id: null,
    note: "",
    roles: [],
    ad_billing_note: "",
    client_email: null,
  })
  const [uniqueString, setUniqueString] = useState("")
  const [noteVal, setNoteVal] = useState("")
  const [adBillingValue, setAdBillingValue] = useState("")

  const [loading, setLoading] = useState(false)
  const [previewLoading, setPreviewLoading] = useState(false)
  const [draftLoading, setDraftLoading] = useState(false)
  const isSolo = props.match.url.includes("solo")
  const isSent = invoiceData && Boolean(invoiceData.sent)

  const [client, setClient] = useState({
    client_id: invoiceData.client_id,
    client_name: invoiceData.client_name,
    client_email: invoiceData.client_email,
    client_phone: invoiceData.client_phone,
  })

  useEffect(
    () => {
      setClient({
        client_id: invoiceData.client_id,
        client_name: invoiceData.client_name,
        client_email: invoiceData.client_email,
        client_phone: invoiceData.client_phone,
      })
    },
    [
      invoiceData.client_id,
      invoiceData.client_name,
      invoiceData.client_email,
      invoiceData.client_phone,
    ]
  )
  const expensesTypesList = useSelector(
    state => state.billing.expensesTypesList
  )
  const paidAmount = useMemo(
    () => {
      if (invoiceData.full_paid) {
        return invoiceData.full_amount
      } else {
        return 0
      }
    },
    [invoiceData]
  )
  const discountAmount = (invoiceData && invoiceData.discount) || 0

  const amounts = useMemo(
    () => {
      if (invoiceData && invoiceData.invoice_id) {
        return calculateTotals(invoiceData.roles, paidAmount, discountAmount)
      }
    },
    [invoiceData, paidAmount, discountAmount]
  )

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  useEffect(
    () => {
      setLoading(true)
      if (id) {
        dispatch(getSoloCall("invoice", id))
          .then(res => {
            setUniqueString(res[0].unique_string || "")
            setInvoiceData({ ...res[0] } || {})
            setNoteVal(res[0].note || "")
            setLoading(false)
          })
          .catch(err => {
            console.log(err)
            dispatch(openSnackBar({ message: "Error getting Invoice" }))
            setLoading(false)
          })
      }
    },
    [id]
  )

  const saveSolo = () => {
    setDraftLoading(true)
    dispatch(
      updateSolo("invoice", id, {
        ...invoiceData,
        note: noteVal,
        ad_billing_note: adBillingValue,
        client_id: client.client_id,
        client_name: client.client_name,
        client_email: client.client_email,
        client_phone: client.phone,
      })
    )
      .then(res => {
        setInvoiceData({
          ...invoiceData,
          note: noteVal,
          invoice_note: noteVal,
          ad_billing_note: adBillingValue,
          client_id: client.client_id,
          client_name: client.client_name,
          client_email: client.client_email,
          client_phone: client.phone,
        })
        dispatch(openSnackBar({ message: "Solo invoice updated" }))
        setDraftLoading(false)
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error updating invoice" }))
        setDraftLoading(false)
      })
  }

  const baseUrl =
    process.env.REACT_APP_ENV === "production"
      ? "https://crewmama.com"
      : process.env.REACT_APP_ENV === "staging"
        ? "https://staging.adesk.app"
        : "http://localhost:3000"

  const openPreview = () => {
    setPreviewLoading(true)
    dispatch(updateSolo("invoice", id, { ...invoiceData, note: noteVal }))
      .then(() => {
        dispatch(openSnackBar({ message: "Invoice auto-saved" }))
        window
          .open(`${baseUrl}/billing/solo-invoice/${id}/preview`, "_blank")
          .focus()
        setPreviewLoading(false)
      })
      .catch(err => {
        console.log(err)
        setPreviewLoading(false)
        dispatch(openSnackBar({ message: "Unable to open preview" }))
      })
  }

  // load expense types list for use in autocomplete
  useEffect(() => {
    if (expensesTypesList.length === 0) {
      dispatch(getExpensesTypesList())
    }
  }, [])

  // check if there are any discounts - using for PDF here to decide if Discount column displays
  const checkDiscount = useMemo(
    () => {
      if (invoiceData && invoiceData.roles.length > 0) {
        let discountArr = []
        invoiceData.roles.map(x =>
          x.expenses.filter(y => {
            if (y.discount && y.discount > 0) {
              discountArr = [...discountArr, y]
            }
            return discountArr
          })
        )
        return discountArr.length > 0
      } else {
        return false
      }
    },
    [invoiceData]
  )

  const isDisabled = invoiceData && invoiceData.full_paid

  const isAdesk =
    useActiveCompanyAdesk() || (invoiceData && invoiceData.company_id === 2)

  const sendDisabled = invoiceData && invoiceData.client_id === null

  return (
    <Fragment>
      <MuiThemeProvider theme={billingTheme}>
        <CrewMamaAppBarComponent history={props.history} />
        <SoloHeader
          type="invoice"
          saveSolo={saveSolo}
          draftLoading={draftLoading}
          dataLoading={loading}
          isSent={isSent}
          soloData={invoiceData}
          setSoloData={setInvoiceData}
          setClient={setClient}
          client={client}
          {...props}
        />
        {loading ? (
          <CircularProgress />
        ) : (
          <BillingPageLayout
            leftContent={
              <Card
                style={
                  viewportWidth < 600
                    ? {
                      padding: "10px",
                      borderRadius: "20px",
                    }
                    : {
                      padding: "30px",
                      borderRadius: "20px",
                    }
                }
              >
                <Box>
                  <SoloTableHeader
                    type="invoice"
                    setSoloData={setInvoiceData}
                    soloData={invoiceData}
                    adBillingValue={adBillingValue}
                    setAdBillingValue={setAdBillingValue}
                    client={client}
                    setClient={setClient}
                  />
                  <SoloTable
                    type="invoice"
                    soloData={invoiceData}
                    setSoloData={setInvoiceData}
                  />
                </Box>
                <Box
                  marginTop="40px"
                  display="flex"
                  flexDirection={viewportWidth < 600 ? "column" : "row"}
                  justifyContent={
                    viewportWidth > 600 ? "space-between" : "center"
                  }
                >
                  <Box width={viewportWidth < 600 ? "100%" : "50%"}>
                    <NoteBox
                      noteVal={noteVal}
                      setNoteVal={setNoteVal}
                      isSolo={isSolo}
                      isDisabled={isDisabled}
                      {...props}
                    />
                  </Box>
                  <Box
                    width={viewportWidth < 600 ? "100%" : "50%"}
                    marginLeft={viewportWidth < 600 ? 0 : "20%"}
                    marginRight={viewportWidth < 600 ? 0 : "20px"}
                    flexShrink={1}
                  >
                    <ExpenseTableTotal
                      data={amounts}
                      discount={discountAmount}
                      addDiscount
                      soloData={invoiceData}
                      setSoloData={setInvoiceData}
                    />
                  </Box>
                </Box>
                <Box style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    style={{
                      color: "#F04031",
                      marginTop: "50px",
                      fontWeight: 550,
                      fontSize: "22px",
                    }}
                    onClick={openPreview}
                    disabled={previewLoading}
                  >
                    Preview
                  </Button>
                </Box>
              </Card>
            }
            rightHeader="Actions"
            rightHeaderButtons={
              <Fragment>
                <Tooltip
                  title={sendDisabled ? "Attach a client to solo first" : ""}
                >
                  <Box>
                    <DownloadPdfButton
                      disabled={sendDisabled}
                      type="invoice"
                      data={{
                        ...invoiceData,
                        users: invoiceData && invoiceData.roles,
                        invoice_note: invoiceData && invoiceData.note,
                        passedAmounts: amounts,
                        company_name:
                          isAdesk && invoiceData.crewmama_or_gtt
                            ? convertAdeskToOrganization(
                              invoiceData.crewmama_or_gtt
                            )
                            : invoiceData.company_name,
                        company_phone: isAdesk
                          ? adeskPhones(invoiceData.crewmama_or_gtt)
                          : invoiceData.company_phone,
                        hasLineDiscounts: checkDiscount,
                      }}
                    />
                  </Box>
                </Tooltip>
                <Box width="10px" />
                <Tooltip
                  title={sendDisabled ? "Attach a client to solo first" : ""}
                >
                  <Box>
                    <CopyLinkButton
                      docType="solo-invoice"
                      uniqueString={uniqueString}
                      disabled={sendDisabled}
                    />
                  </Box>
                </Tooltip>
              </Fragment>
            }
            rightContent={
              <SoloAdminActions
                type="invoice"
                setSoloData={setInvoiceData}
                soloData={{ ...invoiceData, note: noteVal }}
                amounts={amounts}
              />
            }
          />
        )}
      </MuiThemeProvider>
    </Fragment>
  )
}
export default withRouter(SoloInvoice)
